module.exports = __webpack_public_path__ + "img/logo.73df1f39.png";